export default "__VITE_PUBLIC_ASSET__fe723aa6__"